import React from 'react';
import { CheckCircle2, XCircle, AlertTriangle, HelpCircle, MinusCircle } from 'lucide-react';
import { Card } from '../../ui/card';
import { stepMeta } from './format';

const ICONS = { pass: CheckCircle2, fail: XCircle, warn: AlertTriangle, unknown: HelpCircle, skipped: MinusCircle };

// CheckStep is one numbered step of the eligibility checklist. Details are hidden once an
// earlier step has stopped the process.
export default function CheckStep({ index, title, subtitle, status, reason, children }) {
  const meta = stepMeta(status);
  const Icon = ICONS[status] || MinusCircle;
  return (
    <Card className="p-4">
      <div className="flex items-center gap-3">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-surface-2 text-xs font-bold text-ink-dim">{index}</span>
        <div className="flex min-w-0 flex-1 flex-wrap items-baseline gap-x-3">
          <h2 className="text-sm font-bold text-ink">{title}</h2>
          {subtitle && <span className="font-mono text-xs font-medium text-ink-dim">{subtitle}</span>}
        </div>
        <span className={`flex items-center gap-1.5 text-xs font-bold ${meta.tone}`}>
          <Icon className="h-4 w-4" />
          {meta.label}
        </span>
      </div>
      {reason && <p className={`mt-2 pl-9 text-xs font-medium ${meta.tone}`}>{reason}</p>}
      {status !== 'skipped' && children && <div className="mt-3 pl-9">{children}</div>}
    </Card>
  );
}
